export class ApiException extends Error {
  private readonly _message: string;
  private readonly _prefix: string;
  private readonly _statusCode?: number;

  constructor(message: string, prefix: string, statusCode?: number) {
    super(`${message}`);
    this._message = message;
    this._prefix = prefix;
    this._statusCode = statusCode;
  }

  toString(): string {
    if (this._statusCode === undefined) {
      return `${this._prefix}${this._message}`;
    }
    return `[${this._statusCode}] ${this._prefix}${this._message}`;
  }

  get message(): string {
    return this._message;
  }
}

export class BadRequestException extends ApiException {
  constructor(message: string, statusCode: number) {
    super(message, 'Bad Request: ', statusCode);
  }
}

export class UnauthorizedException extends ApiException {
  constructor(message: string, statusCode: number) {
    super(message, 'Unauthorized: ', statusCode);
  }
}

export class ForceLogoutException extends ApiException {
  constructor(message: string, statusCode: number) {
    super(message, 'Unauthorized: ', statusCode);
  }
}

export class ForbiddenException extends ApiException {
  constructor(message: string, statusCode: number) {
    super(message, 'Forbidden: ', statusCode);
  }
}

export class NotFoundException extends ApiException {
  constructor(message: string, statusCode: number) {
    super(message, 'Not Found: ', statusCode);
  }
}

export class ServerErrorException extends ApiException {
  constructor(message: string, statusCode: number) {
    super(message, 'Internal Server Error: ', statusCode);
  }
}

export class UnknownApiException extends ApiException {
  constructor(message: string, statusCode: number) {
    super(message, 'Unknown Api Error: ', statusCode);
  }
}

export class NetworkException extends ApiException {
  constructor() {
    super('', 'Network Connection Failed: ', undefined);
  }
}
